"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue, Ref } from "vue-property-decorator";
import UiDialog from "@/components/dialog/UiDialog.vue";
import API from "@ym-framework/api-utils";
let UpdateDialog = class extends Vue {
  open() {
    return __async(this, null, function* () {
      this.updateDialog.show();
    });
  }
  checkVersion() {
    return __async(this, null, function* () {
    });
  }
  notshow() {
    return __async(this, null, function* () {
      try {
        yield API.put(`api://base.local/storages/session/showUpdateNotice`, {
          "message": "not_show"
        });
        this.close();
      } catch (error) {
        console.log(error);
      }
    });
  }
  gotoDownload() {
    window.open("https://www.kuajingvs.com/download");
    this.close();
  }
  close() {
    this.updateDialog.hide();
  }
};
__decorateClass([
  Ref("updateDialog")
], UpdateDialog.prototype, "updateDialog", 2);
UpdateDialog = __decorateClass([
  Component({
    components: {
      UiDialog
    }
  })
], UpdateDialog);
export {
  UpdateDialog as default
};
